module.exports = __webpack_public_path__ + "static/media/topSelect.8df622c3.svg";